import { render, staticRenderFns } from "./LiquidityPairWidget.vue?vue&type=template&id=b88cee8a&scoped=true&"
import script from "./LiquidityPairWidget.vue?vue&type=script&lang=ts&"
export * from "./LiquidityPairWidget.vue?vue&type=script&lang=ts&"
import style0 from "./LiquidityPairWidget.vue?vue&type=style&index=0&id=b88cee8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88cee8a",
  null
  
)

export default component.exports